import SvgIcon from "../components/SvgIcon"

const IconMaskB = () => {
  return (
    <SvgIcon viewBox="0 0 36 36">
      <path
        d="M11.846 8h12.308c1.337 0 1.822.14 2.311.4.49.262.873.646 1.134 1.135.262.489.401.974.401 2.31v12.31c0 1.336-.14 1.821-.4 2.31-.262.49-.646.873-1.135 1.134-.489.262-.974.401-2.31.401h-12.31c-1.336 0-1.821-.14-2.31-.4-.49-.262-.873-.646-1.134-1.135-.262-.489-.401-.974-.401-2.31v-12.31c0-1.336.14-1.821.4-2.31.262-.49.646-.873 1.135-1.134.489-.262.974-.401 2.31-.401z"
        transform="translate(-446 -442) translate(446 442)"
      />
    </SvgIcon>
  )
}

export default IconMaskB
